import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ResourceNameService, UserService } from 'dp-formio';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
})

export class PagesComponent extends BaseComponent implements OnInit {
    formKey: string;
    submission: any = {};
    extraOptions: any;

    formReady = false;

    constructor(public injector: Injector,
        private resourceNameService: ResourceNameService,
        private userService: UserService) { super(injector); }

    ngOnInit() {
        this.route.params.subscribe(params=>{
            this.formReady = false;
            this.loadModelsManagementResource();
        });
    }

    private loadModelsManagementResource() {
        this.sub = this.resourceNameService.modelsManagementResource.subscribe(
            (data) => {
                if (!data) this.getModelsManagement();
                else this.checkResource(data);
            }
        );
    }

    private getModelsManagement() {
        this.sub = this.resourceNameService
            .getManageMenuData()
            .subscribe((data) => {
                this.checkResource(data);
            });
    }

    private async checkResource(gridMenu: any[]) {
        if (gridMenu && gridMenu.length) {
            const item = gridMenu[0].data.menus
                .filter(item => !item.appearance?.length || item.appearance.includes('frontOffice'))
                .find(item => item.isActive &&
                    (
                        (item.type == 'page' && location.pathname.includes(item.route)) ||
                        (item.type == 'resource' && location.pathname.includes(item.menu.path))
                    )
                );
            if (!item) {
                this.router.navigate(['/404']);
            }
            //check permission
            const menuItem = this.resourceNameService.generateMenuItem(item, '');
            const _userInRoles = this.sessionService.isUserInRole(menuItem.permissions, null, false);
            if (_userInRoles || !menuItem.permissions.length) {
                const isLoggedIn = await this.keycloakService.isLoggedIn();
                const data = await this.userService.getUserData(isLoggedIn ? await this.keycloakService.getToken() : null);
                const params = this.route.snapshot.params;
                this.extraOptions = this.route.snapshot.queryParams;

                this.formKey = params.formKey;
                this.submission.data = { ...data, ...this.extraOptions };
                this.formReady = true;
            } else {
                this.router.navigate(['/403']);
            }
        } else {
            this.router.navigate(['/404']);
        }
    }


}
